import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=6aaabf04&"
import script from "./NumberInput.vue?vue&type=script&lang=ts&"
export * from "./NumberInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports